import React, { useState, useEffect } from "react";
import Axios from './../../../../utils/api/axiosConf';
import { url } from './../../../../utils/api/api';
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import LOADING from "../../../../components/loading/loading";
import UPLOAD from "../../../../components/uoload/upload";
import { Col, Row } from "antd";
import { Uploder } from "../../../../utils/utils";
import MULTISELECT from "../../../../components/multiSelect/multiSelect";
import BUTTON from "./../../../../components/buttons/button"

export default function AboutCoach(props) {
    const userId = props.userId;
    const [loading, setLoading] = useState({ 1: false, 2: false, 3: false });
    const [data, setData] = useState();
    const [image, setImage] = useState({ "id": null, "link": null })
    const [items, setItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([])


    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}specialtie/v1/get-all-skill`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    var x = [];
                    for (const iterator of response.data) {
                        x.push({
                            label: iterator.title,
                            value: iterator._id,
                        })
                        setItems(x)
                    }
                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [])

    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}users/coche-skills/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setData(response.data)
                    setLoading({ ...loading, 1: false })
                    if (response.data.profile != undefined) {
                        setImage({ "id": response.data.profile._id, "link": `${url}${response.data.profile.path}` })
                    }
                    var x = [];
                    for (const iterator of response.data.specialties) {
                        x.push({
                            value: iterator._id,
                        })
                        setSelectedItems(x)
                    }
                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                console.log(error)
            });
    }, [])

    const upload = async (e) => {
        var res = await Uploder(e, "profile")
        if (res.status == 200 || res.status == 201) {
            setLoading({ ...loading, 2: false })
            setImage({ "id": res.data._id, "link": `${url}${res.data.path}` })
        }
    }

    const updateCoachProfile = () => {
        setLoading({ ...loading, 3: true })
        var x = [];
        for (const iterator of selectedItems) {
            x.push(iterator)
        }
        var data = {
            "profile": image.id != null ? image.id : "",
            "specialties": x
        }
        Axios.patch(`${url}users/edit-coche-skills/${userId}`, data)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setLoading({ ...loading, 3: false })
                    GreenNotif(response.message)
                    props.pager(1)
                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 3: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                setLoading({ ...loading, 3: false })

            });
    }


    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row >
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                        <p style={{ margin: "15px !important" }}>انتخاب عکس مربی :</p>
                        <div style={{ width: "250px", height: '150px', margin: "10px 0" }}>
                            <UPLOAD
                                accept={".png,.jepg,.jpg"}
                                click={(e) => {
                                    setLoading({ ...loading, 2: true })
                                    upload(e)
                                }} loading={loading[2]} defultImage={image.link} />
                        </div>
                        <p>انتخاب مهارت های مربی‌:</p>
                        <MULTISELECT
                            options={items}
                            placeholder={"مهارت های مربی را انتخاب کنید"}
                            value={selectedItems}
                            click={(e) => setSelectedItems(e)} />
                    </Col>
                
                </Row>
                <Row style={{ marginTop: '64px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON text={"بروزرسانی درباره مربی"}
                            loading={loading[3]}
                            event={(e) => updateCoachProfile()}
                            type={"submit"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => props.pager(1)} text="رد کردن" type={"cancel"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }
}
